// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1cTIu","approved":"Status_approved__1wbJx","rejected":"Status_rejected__3oFhL","expired":"Status_expired__EbH6Y","label":"Status_label__3MQlN"};